// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TSearchOffersDesktopRequest,
  TSearchOffersDesktopModel,
  IMappers,
  TSearchOffersDesktopResponse_,
  TSearchOffersDesktopResponse,
  TSearchOffersDesktopResponse_1,
  TSearchOffersDesktopResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';

export function createSearchOffersDesktopModel(parameters: TSearchOffersDesktopRequest): TSearchOffersDesktopModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'search-offers',
    pathApi: '/v3/search-offers-desktop/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ISearchOffersDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TSearchOffersDesktopRequest;
}

export async function fetchSearchOffersDesktop<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ISearchOffersDesktopOptions<TResponse200, TResponse400>): Promise<
  TSearchOffersDesktopResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createSearchOffersDesktopModel(parameters),
    config,
  )) as FetchResponse<TSearchOffersDesktopResponse_>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TSearchOffersDesktopResponse_1, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as TSearchOffersDesktopResponseError, headers);
    }
  }
  return {
    statusCode,
    response,
    headers: Array.from(headers),
  } as TSearchOffersDesktopResponse;
}
